import { BaseFeature, FeatureType } from '@core/shared/feature';
export class PflegethekeBillingBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@pflegetheke/billing/feature","featureId":"pflegetheke-billing"},
      bundledItemModels: ["BillingReportItem", "BillingMembershipMapItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: false,
      dependencies: ['pflegetheke-questions', 'common-membership', 'common-health-insurances', 'pflegetheke-membership-plugins-insurance'],
      plugins: [
      // {forPlatform:'frontend', type:FeatureType.Permanent, pluginClassName:'PflegethekeBillingFrontendFeature'},
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'PflegethekeBillingFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'PflegethekeBillingFrontendAdminFeature'
      },
      // {forPlatform:'backend', type:FeatureType.Permanent, pluginClassName:'PflegethekeBillingBackendFeature'},
      {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'PflegethekeBillingBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}